import React from 'react'
import { array, string } from 'prop-types'
import ReduxStores from '../../../../stores/connects'
import { HelperCCMessages } from './ccMessages.jsx'

class HelpWithNewBooking extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ccData: HelperCCMessages.initialData
    }
  }

  componentDidMount () {
    HelperCCMessages.getData(data => {
      this.setState(data)
    })
  }

  render () {
    const { functionParams, id } = this.props
    const { ccData } = this.state
    return (
      <span id={id}>{ ccData.allAgents.TotalAgents || (functionParams && functionParams[0]) || '277' }</span>
    )
  }
}

HelpWithNewBooking.propTypes = {
  functionParams: array,
  id: string.isRequired
}

export default ReduxStores(HelpWithNewBooking, ['agents'])



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/contactCentre/callsOnQueue.jsx